export const CLASS_PREFIX = 'dlpd';
